import CreateOrEditTaskPage from "~/pages/tasks/task_create/CreateOrEditTaskPage.vue";

export default [
  {
    path: "/create/in/:category/for/:class/:id",
    component: CreateOrEditTaskPage,
    name: "createForInstance",
  },
  {
    path: "/create/:category",
    component: CreateOrEditTaskPage,
    name: "create",
  },
  {
    path: "/:task/edit",
    component: CreateOrEditTaskPage,
    name: "edit",
  },
];
